import { INIT_RENDER_PLAYER } from "dve-plugins-player/Render";
import { CreateBox } from "@babylonjs/core/Meshes/Builders/boxBuilder.js";
import { EdgesRenderer } from "@babylonjs/core/Rendering/edgesRenderer.js";
import { StandardMaterial } from "@babylonjs/core/Materials/standardMaterial.js";
import { DVER } from "divine-voxel-engine/Render";
import { SetUpControls } from "./SetUpControls";
import { PlayerAudio } from "./PlayerAudio";
export async function InitPlayer(scene, camera) {
    const model = CreateBox("box", {
        width: 0.8,
        height: 0.8,
        depth: 0.8,
    });
    const player = await INIT_RENDER_PLAYER(
    //@ts-ignore
    scene, 
    //@ts-ignore
    camera, DVER, {
        //@ts-ignore
        CreateBox,
        //@ts-ignore
        EdgesRenderer,
        //@ts-ignore
        StandardMaterial,
    }, model);
    player.active = true;
    await SetUpControls(player);
    PlayerAudio.INIT(player);
}
